import { render, staticRenderFns } from "./AccountFaxes.vue?vue&type=template&id=86d1330e&"
import script from "./AccountFaxes.vue?vue&type=script&lang=js&"
export * from "./AccountFaxes.vue?vue&type=script&lang=js&"
import style0 from "./AccountFaxes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports